// token key
export const TOKEN_KEY = 'TOKEN'

// user info key
export const USER_INFO_KEY = 'USER_INFO'

export const USERCONFIG = 'user_config'

/** 访客标志 */
export const GUESTMODE = 'guestMode'

export enum EGlobalConfig {
  token = 'token',
  apiSrc = 'apiSrc',
  pushSrc = 'pushSrc',
  platformName = 'platformName',
  icoUrl = 'icoUrl',
  handicap = 'handicap',
  language = 'language',
  color = 'color',
  currencyId = 'currencyId',
  cbs = 'cbs',
  tutorialPop = 'tutorialPop',
  themeText = 'themeText',
  nickname = 'nickname',
  noType = 'noType',
  hideBigData = 'hideBigData',
  enableSportFilter = 'enableSportFilter',
}

/** 升降颜色 1 红升绿降, 2 绿升红降  */
export const updownKey = 'updown-v1.1'

/** 是横向布局 */
export const isHorizontal = 'isHorizontal'

/** 收藏的id */
export const LoveLeagueIdsKey = 'loveLeagueIds'

/** 下注的订单 */
export const BetListKey = 'betList'

/** 下注的订单 marketid */
export const BetListMarketIdsKey = 'betListMarketIds'

/** 赔率偏好 */
export const EOddsChange = 'oddsChange'

/** 提前结算 */
export const EPay = 'pay'

/** 联赛筛选方式 */
export const EMatchOrderBykey = 'matchOrderBy'

/** 详情置顶id */
export const topMarket = 'topMarket'

/** 排序 */
export const sportOptSort = 'sportOptSort-v1.0'
